import { formatUSD } from "@/lib/format";

export default function StockWatchlist({ stocks }) {
  const liveCount = stocks.filter((s) => s.source === "live").length;
  return (
    <section data-testid="stock-watchlist" className="border border-arena-line bg-white">
      <div className="px-6 lg:px-8 py-4 border-b border-arena-line flex items-baseline justify-between flex-wrap gap-2">
        <h2 className="font-display font-black text-2xl tracking-tighter">UNIVERSE</h2>
        <div className="flex items-center gap-4 text-[10px] font-mono uppercase tracking-[0.25em] text-arena-soft">
          <span className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 bg-profit" /> {liveCount}/{stocks.length} live
          </span>
          <span>refresh 60s</span>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 arena-grid">
        {stocks.map((s) => (
          <div
            key={s.symbol}
            data-testid={`stock-${s.symbol}`}
            className="bg-white p-4 lg:p-5 hover:bg-arena-alt/50 transition-colors"
          >
            <div className="flex items-center justify-between">
              <div className="font-display font-black text-base tracking-tight">{s.symbol}</div>
              <span
                className={`w-1.5 h-1.5 ${s.source === "live" ? "bg-profit" : "bg-arena-mute"}`}
                title={s.source === "live" ? "Live price" : "Cached fallback"}
              />
            </div>
            <div className="font-mono font-bold text-lg tabular-nums mt-1">
              {formatUSD(s.price)}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
